import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const VEITSBRONN_SITE = "https://22studiosveitsbronn.de";

/** Alte /veitsbronn-Pfade auf ihre Entsprechung unter der eigenen Domain. */
const PFADE: Record<string, string> = {
  "/veitsbronn": "/",
  "/veitsbronn/haare": "/haare",
  "/veitsbronn/makeup": "/makeup",
  "/veitsbronn/brows-lashes": "/brows-lashes",
  "/veitsbronn/barbershop": "/barbershop",
  "/veitsbronn/team": "/team",
  "/veitsbronn/leistungen": "/leistungen",
  "/veitsbronn/anfrage": "/anfrage",
  "/veitsbronn/impressum": "/impressum",
  "/veitsbronn/datenschutz": "/datenschutz",
};

/**
 * Veitsbronn ist seit dem 02.10.2026 eine eigene Website.
 * Wer noch einen alten Link hat, landet hier und wird dorthin geschickt —
 * auf die passende Seite, nicht pauschal auf die Startseite.
 *
 * `replace` statt `assign`, damit der Zurück-Knopf nicht in einer Schleife endet.
 */
const NachVeitsbronn = () => {
  const location = useLocation();
  const pfad = location.pathname.replace(/\/+$/, "") || "/veitsbronn";
  const ziel = `${VEITSBRONN_SITE}${PFADE[pfad] ?? "/"}`;

  useEffect(() => {
    window.location.replace(ziel);
  }, [ziel]);

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-md text-center">
        <h1 className="font-serif text-2xl font-light text-foreground md:text-3xl">
          22 Studios Veitsbronn hat eine eigene Seite
        </h1>
        <p className="mt-4 text-muted-foreground font-light">
          Wir leiten dich weiter. Falls nichts passiert:{" "}
          <a href={ziel} className="text-highlight underline underline-offset-4">
            22studiosveitsbronn.de
          </a>
        </p>
      </div>
    </main>
  );
};

export default NachVeitsbronn;
